import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet, type Campaign } from "../api/client";
import { CampaignGrid } from "../components/CampaignTile";
import { EmptyMessage } from "../components/EmptyMessage";
import { PageHeader } from "../components/PageHeader";

export function CampaignsPage() {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet<{ campaigns: Campaign[] }>("/campaigns")
      .then((d) => {
        if (!cancelled) setCampaigns(d?.campaigns ?? []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <PageHeader
        title="Campaigns"
        actions={
          <Link
            className="ne__btn ne__btn--secondary ne__btn--secondary--halo ne__btn--icon ne__btn--lg"
            to="/app/campaigns/new/edit/email"
            title="Create new campaign"
          >
            <i className="ne__icon__add" />
          </Link>
        }
      />

      <div className="ne__campaigns">
        {loading ? (
          <EmptyMessage>
            <p>Loading campaigns…</p>
          </EmptyMessage>
        ) : null}

        {!loading && campaigns.length === 0 ? (
          <EmptyMessage title='Sorry, no campaigns found! Click "+" to start a new campaign.' />
        ) : null}

        {!loading && campaigns.length > 0 ? (
          <CampaignGrid campaigns={campaigns} />
        ) : null}
      </div>
    </>
  );
}
